var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71582 11.0552V9.02295H6.79951C7.99337 9.02295 8.95851 10.0078 8.95851 11.226",
    stroke: "#C72035",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83377 6.88228C6.88442 6.88228 7.73614 6.01321 7.73614 4.94114C7.73614 3.86908 6.88442 3 5.83377 3C4.78312 3 3.9314 3.86908 3.9314 4.94114C3.9314 6.01321 4.78312 6.88228 5.83377 6.88228Z",
    stroke: "#C72035",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5039 11.226V9.02295H19.5876C20.7815 9.02295 21.7466 10.0078 21.7466 11.226",
    stroke: "#C72035",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6277 6.88228C19.6784 6.88228 20.5301 6.01321 20.5301 4.94114C20.5301 3.86908 19.6784 3 18.6277 3C17.5771 3 16.7253 3.86908 16.7253 4.94114C16.7253 6.01321 17.5771 6.88228 18.6277 6.88228Z",
    stroke: "#C72035",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.9998H24",
    stroke: "#C72035",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0075 18.8878V13.793C10.0075 13.1726 9.51657 12.6716 8.90848 12.6716H1.66162V18.8878H10.0075V18.8878Z",
    stroke: "#C72035",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8007 18.8878V13.793C22.8007 13.1726 22.3098 12.6716 21.7017 12.6716H14.4548V18.8878H22.8007V18.8878Z",
    stroke: "#C72035",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.5e0f552b.svg";
export { ForwardRef as ReactComponent };